import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Customer } from '../model/customer';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  constructor(private http: HttpClient) { }

  addCustomer(model: Customer):Observable<any> {
    return this.http.post(`${environment.baseUrl}/api/customer/create`, model, { observe: 'response' });
  }
  updateCustomer(model: Customer):Observable<any> {
    return this.http.post(`${environment.baseUrl}/api/customer/update`, model, { observe: 'response' });
  }
  getCustomers():Observable<any>{
    return this.http.get(`${environment.baseUrl}/api/customer/get`, { observe: 'response' });
  }
  searchCustomers(searchterm):Observable<any>{
    return this.http.get(`${environment.baseUrl}/api/customer/search/${searchterm}`, { observe: 'response' });
  }
  getCustomersMasterData():Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/customer/customer-master-data`, { observe: 'response' });
  }
  deleteCustomer(id):Observable<any> {
    return this.http.delete(`${environment.baseUrl}/api/customer/${id}`, { observe: 'response' });
  }
  getCustomerById(id):Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/customer/get/${id}`, { observe: 'response' });
  }
  getTimeLine(id):Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/customer/timeline/${id}`, { observe: 'response' });
  }
  checkFileNo(fileNo):Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/customer/file-no-exists/${fileNo}`, { observe: 'response' });
  }
  getNextFileNo() {
    return this.http.get(`${environment.baseUrl}/api/customer/next-file-no`, { observe: 'response' });
  }
  importSample() {
    return this.http.get(`${environment.baseUrl}/api/customer/get-customer-import-template`, { observe: 'response', responseType: 'blob' });
  }
  importExcel(formdata: FormData) {
    return this.http.post(`${environment.baseUrl}/api/customer/import-bulk`, formdata, { observe: 'response', responseType: 'blob' });
  }
  updateBank( customerId, banks) {
    let params = new HttpParams();
    if(customerId) params = params.append('customerId', customerId);
    return this.http.post(`${environment.baseUrl}/api/customer/update-banks`, banks,{ params: params, observe: 'response' });
  }
}

